export function debounce(delay: number = 300): MethodDecorator {
	// tslint:disable-next-line: only-arrow-functions
	return function (descriptor: PropertyDescriptor) {
		const timeoutKey = Symbol();

		const original = descriptor.value;
		if (!original) {
			return;
		}

		descriptor.value = function (...args) {
			clearTimeout(this[timeoutKey]);
			this[timeoutKey] = setTimeout(
				function() {
					original.apply(this, args);
				}.bind(this),
				delay
			);
		};

		return descriptor;
	};
}
